import { types, actions } from './requests'
export const DELETEMOLD_TYPES = {
    ...types('DELETEMOLD'),
}
export const DELETEMOLD_ACTIONS = {
    ...actions('DELETEMOLD'),
}